type CalendarExportLink = {
  uri: string;
};

const calendarExportLink: CalendarExportLink = {
  uri: "",
};

export type { CalendarExportLink };

export { calendarExportLink };
